import React from "react";
import { Box, VStack, HStack, Text, Badge } from "@chakra-ui/react";
import { formatDateTime } from "../utils/resumeHelpers";

const ResumeVersionTimeline = ({ versions = [] }) => {
  if (!versions.length) {
    return <Text color="gray.500">Only initial version exists.</Text>;
  }

  return (
    <VStack align="stretch" spacing={3}>
      {versions.map((version) => (
        <Box key={version._id} p={3} borderWidth="1px" borderRadius="md">
          <HStack justify="space-between">
            <Text fontWeight="semibold">v{version.latestVersion}</Text>
            <Badge colorScheme="blue">{version.status || "active"}</Badge>
          </HStack>
          <Text fontSize="sm" color="gray.600" mt={2}>
            Uploaded {formatDateTime(version.uploadedAt)}
          </Text>
        </Box>
      ))}
    </VStack>
  );
};

export default ResumeVersionTimeline;
